class Files {
    constructor(apiService = null) {
        this.obj_name = 'files';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                // GET 請求
                apiConfig.url += `?filePath=${parameter}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                // POST 請求
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'delete') {
                // DELETE 請求
                this.apiService.delApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 取得圖片網址
    getImage(parameter) {
        return `${this.apiService.url}${this.obj_name}/readFiles?filePath=${parameter}`;
    }

    // 取得外部檔案網址
    getOutsideFiles(parameter) {
        return `${this.apiService.url}${this.obj_name}/readFilesOutside?filePath=${parameter}`;
    }

    // 102 圖片顯示
    async readFiles(parameter) {
        return this.callApi('get', 'readFiles', parameter);
    }

    // 103 上傳檔案
    async uploadFiles(parameter, progressEvent = null) {
        return this.callApi('post', 'uploadFiles', parameter, progressEvent);
    }

    // 104 刪除檔案
    async deleteFiles(parameter) {
        return this.callApi('delete', 'deleteFiles', parameter);
    }

    // 105 外部檔案顯示
    async readFilesOutside(parameter) {
        return this.callApi('get', 'readFilesOutside', parameter);
    }

    //101上傳標籤機圖案
    async sendLabel(parameter, progressEvent = null) {
        return this.callApi('post', 'sendLabel', parameter, progressEvent);
    }

}

export default Files;
